const basicObjectToArrayMapper =
  (dataObj: { [key: string]: any }) => (mapper: any) =>
    Object.entries(dataObj).reduce(mapper, []);

export default basicObjectToArrayMapper;
